import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgTextCursorAlphabet = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M2.46506 8.66612H6.86957H2.46506Z",
		fill: "#EA580C"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M9.33398 14.6663C9.95396 14.6663 10.264 14.6663 10.5183 14.5982C11.2085 14.4133 11.7476 13.8742 11.9325 13.184C12.0006 12.9296 12.0006 12.6197 12.0006 11.9997M12.0006 11.9997C12.0006 12.6197 12.0007 12.9296 12.0688 13.184C12.2537 13.8742 12.7928 14.4133 13.483 14.5982C13.7373 14.6663 14.0473 14.6663 14.6673 14.6663M12.0006 11.9997V7.99967M9.33398 1.33301C9.95396 1.33301 10.264 1.33301 10.5183 1.40116C11.2085 1.58609 11.7476 2.12519 11.9325 2.81537C12.0006 3.0697 12.0006 3.37969 12.0006 3.99967M12.0006 7.99967L12.0006 3.99967C12.0006 3.37969 12.0006 3.0697 12.0688 2.81537C12.2537 2.12519 12.7928 1.58609 13.483 1.40116C13.7373 1.33301 14.0473 1.33301 14.6673 1.33301M12.0006 7.99967H13.3396M12.0006 7.99967H10.6673M1.33398 11.9995L3.755 4.86461C3.8927 4.47905 4.25791 4.22168 4.66732 4.22168C5.08814 4.22168 5.46083 4.49336 5.5896 4.89399L8.00065 11.9995M2.46506 8.66612H6.86957",
		stroke: "#EA580C",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
const ForwardRef = forwardRef(SvgTextCursorAlphabet);
export default ForwardRef;
